import React from 'react';

//Add
import ImgESTj from '../img/personality/personality_ESTj.png';
import ImgESTp from '../img/personality/personality_ESTp.png';
import ImgESFj from '../img/personality/personality_ESFj.png';
import ImgESFp from '../img/personality/personality_ESFp.png';
import ImgENTj from '../img/personality/personality_ENTj.png';
import ImgENTp from '../img/personality/personality_ENTp.png';
import ImgENFj from '../img/personality/personality_ENFj.png';
import ImgENFp from '../img/personality/personality_ENFp.png';
import ImgISTj from '../img/personality/personality_ISTj.png';
import ImgISTp from '../img/personality/personality_ISTp.png';
import ImgISFj from '../img/personality/personality_ISFj.png';
import ImgISFp from '../img/personality/personality_ISFp.png';
import ImgINTj from '../img/personality/personality_INTj.png';
import ImgINTp from '../img/personality/personality_INTp.png';
import ImgINFj from '../img/personality/personality_INFj.png';
import ImgINFp from '../img/personality/personality_INFp.png';

function Comp (props) {
  let src = null;
  if (props.type16 === 'ESTj') {
    src = ImgESTj;
  }
  else if (props.type16 === 'ESTp') {
    src = ImgESTp;
  }
  else if (props.type16 === 'ESFj') {
    src = ImgESFj;
  }
  else if (props.type16 === 'ESFp') {
    src = ImgESFp;
  }
  else if (props.type16 === 'ENTj') {
    src = ImgENTj;
  }
  else if (props.type16 === 'ENTp') {
    src = ImgENTp;
  }
  else if (props.type16 === 'ENFj') {
    src = ImgENFj;
  }
  else if (props.type16 === 'ENFp') {
    src = ImgENFp;
  }
  else if (props.type16 === 'ISTj') {
    src = ImgISTj;
  }
  else if (props.type16 === 'ISTp') {
    src = ImgISTp;
  }
  else if (props.type16 === 'ISFj') {
    src = ImgISFj;
  }
  else if (props.type16 === 'ISFp') {
    src = ImgISFp;
  }
  else if (props.type16 === 'INTj') {
    src = ImgINTj;
  }
  else if (props.type16 === 'INTp') {
    src = ImgINTp;
  }
  else if (props.type16 === 'INFj') {
    src = ImgINFj;
  }
  else if (props.type16 === 'INFp') {
    src = ImgINFp;
  }

	return (
		<div>
      <img
        src={ src  }
        style={{
          width:props.width,
          height:'auto',
          borderRadius: '50%',
        }}
        alt=''
      />
		</div>
	)
}

export default Comp;
